import * as React from 'react';

import { TagContent } from './tag-content';
import * as Styled from './tag.styles';
import type { LinkTagProps } from './tag.types';

export const LinkTag = React.forwardRef<HTMLAnchorElement, LinkTagProps>(
  (
    {
      badgeProps,
      children,
      className,
      disabled,
      dragging,
      fontWeight,
      hideBorder,
      href,
      leadingIcon: LeadingIcon,
      maxWidth,
      onClick,
      profile,
      rel,
      selected,
      showMiniBadge,
      size = 'medium',
      slotContent,
      target,
      trailingIcon: TrailingIcon,
      ...props
    },
    forwardedRef
  ): JSX.Element => {
    const handleOnClick = (event: React.MouseEvent<HTMLElement>): void => {
      if (disabled) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      onClick?.(event);
    };

    return (
      <Styled.InteractiveTag
        $disabled={disabled}
        $dragging={dragging}
        $fontWeight={fontWeight}
        $hideBorder={hideBorder}
        $profile={Boolean(profile)}
        $selected={selected}
        $size={size}
        aria-disabled={disabled}
        as="a"
        className={className}
        data-xds="LinkTag"
        href={href}
        onClick={handleOnClick}
        ref={forwardedRef as React.ForwardedRef<any>}
        rel={rel}
        tabIndex={disabled ? -1 : props.tabIndex}
        target={target}
        {...props}
      >
        <TagContent
          badgeProps={badgeProps}
          disabled={disabled}
          leadingIcon={
            LeadingIcon && (
              <LeadingIcon aria-hidden="true" width={18} height={18} />
            )
          }
          maxWidth={maxWidth}
          badgeSpacing={!!LeadingIcon && !children && !!badgeProps}
          profile={profile}
          selected={selected}
          showMiniBadge={showMiniBadge}
          size={size}
          slotContent={slotContent}
          trailingIcon={
            TrailingIcon && (
              <TrailingIcon aria-hidden="true" width={18} height={18} />
            )
          }
        >
          {children}
        </TagContent>
      </Styled.InteractiveTag>
    );
  }
);

LinkTag.displayName = 'LinkTag';
